import { ClaimType } from "@hooks/useClaims";
import { format } from "date-fns";

export const validateEmail = (email: string) => {
  const emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test(email);
};

export const isExternalLink = (link: string | null) => link?.startsWith("http");

export const getSectionDataByKey = (pageData: any, key: string) =>
  pageData?.sections.find((section: any) => {
    const sectionDetailskey =
      "section_details" in section ? "section_details" : "sectionDetails";

    return section[sectionDetailskey].section_id === key;
  });

export const createCookieName = (x: string, prefix = "banner") => {
  const text = x.replaceAll(" ", "-");
  return `cookie-${prefix}-${text.slice(0, 20)}`;
};

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const trimText = (str: string, len: number = 15) => {
  if (str.length > len) {
    return str.substring(0, len) + "...";
  }
  return str;
};

export const setSubscribedToEmail = (isSubscribed: boolean) => {
  sessionStorage.setItem("isSubscribed", `${isSubscribed}`);
  window.dispatchEvent(new Event("storage"));
};

export const isSubscribedToEmail = () => {
  return sessionStorage.getItem("isSubscribed") === "true";
};

export const getUTCEquivalentDate = (dateString: string): Date => {
  // Parse the date string in UTC by appending 'UTC' and creating a Date object
  return new Date(`${dateString} UTC`);
};

export const isKernelAirdropClaim = (type: ClaimType) =>
  [ClaimType.KERNEL_S3V1, ClaimType.KERNEL_S3V1_BSC].includes(type);

export const formatDate = (date: string) => {
  if (!date) return "-";
  return format(new Date(date), "d MMM yyyy");
};

export const isAmountClaimedOrAvailable = (
  availableAmount: bigint | undefined,
  claimedAmount: bigint | undefined
) => {
  return (
    (availableAmount && availableAmount > 0n) ||
    (claimedAmount && claimedAmount > 0n)
  );
};
